import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ToggleContainer, ToggleSlider, ToggleInput, CustomIcon } from './mixins';
export const Toggle = ({ onChange, isChecked = false, disabled = false, size = 'small' }) => {
    const [checkStatus, setCheckStatus] = useState(isChecked);
    const { colors } = useContext(ThemeContext);
    const iconZise = {
        small: '12',
        medium: '13',
        large: '16',
    };
    const setIconColor = () => {
        if (disabled) {
            return colors.grey24;
        }
        if (!checkStatus) {
            return colors.grey0;
        }
        return colors.primary.normal;
    };
    // Actualizar valor
    useEffect(() => {
        setCheckStatus(isChecked);
    }, [isChecked]);
    return (React.createElement(ToggleContainer, { size: size },
        React.createElement(ToggleInput, { onChange: (event) => {
                if (!disabled) {
                    setCheckStatus(!checkStatus);
                    onChange && onChange(event);
                }
            }, type: "checkbox", checked: checkStatus }),
        React.createElement(ToggleSlider, { disabled: disabled, checked: checkStatus, size: size },
            React.createElement(CustomIcon, { name: `icon-light-${checkStatus ? 'checkmark' : 'close'}`, color: setIconColor(), size: iconZise[size], position: size, checked: checkStatus }))));
};
